import { createDisappointedFrames } from "../../core/personality-keyframes.js";

export const meta = Object.freeze({
  id: "disappointed",
  label: "Enttäuscht",
  duration: 2500,
  description: "Orbi sackt zusammen, senkt den Blick und zeigt einen kleinen traurigen Mund.",
  tags: ["body", "expression", "emotion", "one-shot", "loopable"],
});

export async function run({ elements, animate }) {
  const frames = createDisappointedFrames();
  const options = { duration: meta.duration, easing: "linear" };
  const animations = [
    animate(elements.actor, frames.body, options),
    animate(elements.eyes, frames.eyes, options),
    animate(elements.brows, frames.brows, options),
    animate(elements.browLeft, frames.browLeft, options),
    animate(elements.browRight, frames.browRight, options),
    animate(elements.mouthFrown, frames.mouth, options),
    animate(elements.glow, frames.glow, options),
  ];
  await Promise.allSettled(animations.map(({ finished }) => finished));
}
